module.exports = __webpack_public_path__ + "img/Logo_dark.b5d80ba0.svg";